<template>
  <div class="summary-container">
    <div class="agreement-container">
      <h2>KYC Upload</h2>
      <p>Please upload all the required documents.</p>

      <modal-sucess
        v-if="modalSucess"
        @close="modalSucess = false"
        :message="messageSuccess"
      ></modal-sucess>

      <modal-error
        v-if="showModalError"
        :modalstateError="messageModal"
        @close="showModalError = false"
      ></modal-error>

      <form>
        <div class="kyc-row">
          <div class="first">
            <h4>Means of Identification</h4>
            <input-select v-model="form.moi" :items="mois" />
          </div>
          <div>
            <h4>Choose Image</h4>
            <div class="image-upload">
              <p class="image-name">{{ image }}</p>
              <input
                class="image-upload-button"
                type="file"
                id="file"
                ref="moi_file"
                @change="handleFileUpload"
                accept="image/*"
              />
              <label for="file"
                ><a-spin :spinning="spinnings" />Choose Image</label
              >
            </div>
            <p>Max upload size is 5MB</p>
          </div>
        </div>

        <h4>Select Expiry Date</h4>
        <date-picker
          v-model="value1"
          class="date-upload"
          :default-value="new Date()"
          :disabled-date="disabledBeforeTodayAndAfterAWeek"
        ></date-picker>

        <div class="kyc-row">
          <div class="first">
            <h4>Utility Bill</h4>
            <input-select v-model="form.utility" :items="utilities" />
          </div>
          <div>
            <h4>Choose Image</h4>
            <div class="image-upload">
              <!-- NEW INPUTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT -->
              <!-- <a-upload
                v-model:file-list="fileList"
                name="file"
                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                :headers="headers"
                accept="image/*"
                @change="handleChange"
              >
                <a-button>
                  <upload-outlined></upload-outlined>
                  Click to Upload
                </a-button>
              </a-upload> -->

              <p class="image-name">{{ image2 }}</p>
              <input
                class="image-upload-button"
                type="file"
                id="file2"
                ref="utility_file"
                @change="handleFileUpload2"
                accept="image/*"
              />
              <label for="file2"
                ><a-spin :spinning="spinnings2" />Choose Image</label
              >
            </div>
            <p>Max upload size is 5MB</p>
          </div>
        </div>
      </form>

      <div v-if="loader" className="text-center">
        <div class="download-button">
          <div
            class="spinner-border"
            style="width: 2rem; height: 2rem"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div v-else>
        <button @click="makeRequest" class="download-button" type="button">
          Submit
        </button>
      </div>
    </div>
    <div class="illustration">
      <div class="description">
        Kindly upload a means of identification and your utility bill.
      </div>
      <img
        :src="require('../../../../assets/img/polygon.svg')"
        class="polygon"
        alt="Comment Bubble"
      />
      <img :src="require('../../../../assets/img/female-wave.gif')" alt="" />
    </div>
  </div>
</template>

<script>
// import { ref } from "vue";
// import { message } from "ant-design-vue";

import { mapActions, mapGetters } from "vuex";

import InputField from "../components/InputField.vue";
import InputSelect from "../components/InputSelect.vue";

import axios from "axios";
import ModalError from "../../kitchen/Onboarding/modal-error.vue";
import ModalSucess from "../../kitchen/Onboarding/ModalSuccess.vue";
import VueSweetalert2 from "vue-sweetalert2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Vue from "vue";
import "sweetalert2/dist/sweetalert2.min.css";
import Cookie from "js-cookie";
import VueBase64FileUpload from "vue-base64-file-upload";

export default {
  name: "KYC",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  components: {
    InputField,
    InputSelect,

    VueSweetalert2,
    DatePicker,
    VueBase64FileUpload,
    ModalError,
    ModalSucess
  },
  computed: {
    ...mapGetters(["getUserSession"])
  },
  data() {
    return {
      time1: null,
      spinnings: false,
      spinnings2: false,
      value1: new Date(),
      msg: "",

      customImageMaxSize: 3,
      loader: false,

      form: {
        moi_Exp_Date: "",
        moi: "",
        utility: ""
      },
      image: "",
      image2: "",
      showModalError: false,
      modalSucess: false,
      stage: "",
      nextPageName: "",
      moi_file: "",
      utility_file: "",
      formErrors: {},
      message: "You passed the KYC documents stage",

      // activeIndex: 0,
      summary: {},
      mois: [
        { id: "Driving License", name: "Driving License" },
        { id: "International Passport", name: "International Passport" }
      ],
      utilities: [
        { id: "Waste Bill", name: "Waste Bill" },
        { id: "Nepa Bill", name: "Electricity Bill" }
      ]
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    handleFileUpload(e) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const HTTP = this.$httpUtils.FASTHTTP;

      let image_size = e.target.files[0];
      let image_limiter = 5000;
      let convert_image_size = image_size.size / 1024;
      this.spinnings = true;
      if (convert_image_size > image_limiter) {
        this.showErrorMsg({ message: "Uploaded image exceeds 5MB" });
        this.spinnings = false;
      } else {
        this.showInfoMsg({ message: "Uploading image" });
        HTTP.post("/kycfiles/s3-file-upload", formData).then(res => {
          this.spinnings = true;
          if (res && res.data && res.data.url) {
            this.image = res.data.url;
            this.showSuccessMsg({ message: "Image successfully uploaded" });
            this.spinnings = false;
          } else {
            this.showErrorMsg({ message: "Image upload not successful" });
            this.spinnings = false;
          }
        });
      }
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    onFile(file) {
      console.log(file); // file object
    },

    onLoad(dataUri) {
      console.log(dataUri); // data-uri string
    },

    onSizeExceeded(size) {
      alert(
        `Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`
      );
    },

    handleChange(info) {
      const formData = new FormData();
      formData.append("file", info.file);
      console.log("SHOW WHAT'S IN INFO", info.file);
      const HTTP = this.$httpUtils.FASTHTTP;
      HTTP.post("/kycfiles/s3-file-upload", formData).then(res => {
        console.log("AAAAAAAAAAAa", res);
        if (formData.status !== "uploading") {
          console.log(formData, info.fileList);
        }
        if (formData.status === "done") {
          message.success(`${formData.name} file uploaded successfully`);
        } else if (formData.status === "error") {
          message.error(`${formData.name} file upload failed.`);
        }
      });
    },

    handleFileUpload2(e) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const HTTP = this.$httpUtils.FASTHTTP;

      this.spinnings2 = true;
      let image_size = e.target.files[0];
      let image_limiter = 5000;
      let convert_image_size = image_size.size / 1024;
      if (convert_image_size > image_limiter) {
        this.spinnings2 = false;
        this.showErrorMsg({ message: "Uploaded image exceeds 5MB" });
      } else {
        this.showInfoMsg({ message: "Uploading image" });
        HTTP.post("/kycfiles/s3-file-upload", formData).then(res => {
          this.spinnings2 = true;
          if (res && res.data && res.data.url) {
            this.spinnings2 = false;
            this.image2 = res.data.url;
            this.showSuccessMsg({ message: "Image successfully uploaded" });
          } else {
            this.spinnings2 = false;
            this.showErrorMsg({ message: "Image upload not successful" });
          }
        });
      }
    },

    createBase64(file) {
      const reader = new FileReader();
      reader.onload = e => {
        console.log(e.target.result);
      };
      reader.readAsBinaryString(file);
      console.log(reader);
    },

    createBase642(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.image2 = e.target.result;
        console.log(e.target.result);
      };
      reader.readAsBinaryString(file);
    },

    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "You have passed the KYC Uploads Stage",
        icon: "success",
        width: "550px"
      });
    },
    showAlertErr() {
      // Use sweetalert2
      this.$swal({
        title: "error",
        imageWidth: "40px",
        text: "All fields are required",
        icon: "error",
        width: "550px"
      });
    },
    gotoNextState() {
      this.$emit("updateStatus");
    },

    validateInputs() {
      const formErrors = [];

      //
      for (let [field, value] of Object.entries(this.form)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "bvn":
            if (value === "null" || value === "") {
              formErrors[field] = "Bank cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      return formErrors;
    },
    async makeRequest() {
      const HTTP = this.$httpUtils.FASTHTTP;
      let pushedDate = this.value1.toISOString();
      // let formData = new FormData();

      // formData.append("utility_file", this.image2);
      // formData.append("moi", this.form.moi);
      // formData.append("utility_doc", this.form.utility);
      // // formData.append("customer", localStorage.customerId);
      // formData.append("moi_exp_date", this.value1);
      // formData.append("moi_file", this.image);

      const formData = {
        moi: this.form.moi,
        utility_file: this.image2,
        moi_file: this.image,
        utility_doc: this.form.utility,
        moi_exp_date: pushedDate,
        customer: localStorage.customerId
      };

      if (
        this.form.moi &&
        this.value1 &&
        this.form.utility &&
        this.image &&
        this.image2
      ) {
        // console.log(data);

        this.loader = true;
        HTTP.post("/kycfiles/filesapi-file", formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("appUserToken")}`
            }
          })
          .then(res => {
            if (res.data) {
              this.loader = false;
              this.value1 = "";
              this.showSuccessMsg({ message: "Details Succesfully Uploaded!" });
              this.markAsCompleted(true);
              this.showModalError = false;
              this.navTo(this.nextPageName)
            }
          })
          .catch(err => {
            this.loader = false;
          });
      } else {
        this.showModalError = true;
        this.message = "All fields are required";
        setTimeout(() => {
          this.showModalError = false;
        }, 2000);
      }

      //
    },
    // updateStateFunc() {
    //   // console.log("presssed");
    //   const payloadData = {
    //     stateid: 4
    //   };
    //   const HTTP = this.$httpUtils.FASTHTTP;
    //   HTTP.patch("/onboardingstate/nextstate", payloadData).then(res => {
    //     this.$store.commit("saveOnboanrdingState", 4);

    //     if (res.data) {
    //       // this.showAgreement = false
    //     }
    //   });
    // }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
  font-weight: 700;
}

h3 {
  font-weight: 700;
  font-size: 16px;
  color: #000000;
  margin: 20px 0px;
}

h4 {
  width: 327px;
  font-weight: 700;
  font-size: 16px;
  color: #fe7a11;
  margin: 27px 0px 20px;
}

.summary-container {
  display: flex;
  justify-content: space-between;
}

.download-button {
  border-radius: 5px;
  padding: 14px 36px;
  text-align: center;
  max-width: 240px;
  background: #fe7a11;
  border: 1px solid #fe7a11;
  color: #ffffff;
  margin-right: 35px;
  cursor: pointer;
}

.kyc-row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.first {
  margin-right: 10px;
}

.image-upload {
  display: flex;
  justify-content: flex-end;
  background: #fafafa;
  border-radius: 3px;
  border: none;
  width: 100%;
  padding: 17px;
  height: 65px;
}

.image-upload-button {
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
}

.image-upload label {
  box-shadow: 2px 2px 5px 2px #888888;
  padding: 8px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  height: 35px;
  cursor: pointer;
  font-family: "DM Sans";
  font-style: normal;
  color: #727272;
  margin-left: 10px;
}

.image-name {
  max-width: 180px;
  overflow: hidden;
  padding: 7px;
  height: 30px;
}

.date-upload {
  background: #fafafa;
  border-radius: 3px;
  border: none;
  width: 327px;
  padding: 17px;
  height: 65px;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #727272;
}

.summary {
  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;
    width: 70%;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 24px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p:last-child {
        text-align: right;
        width: 50%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .table-base p {
      font-weight: bold;
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/KYC.vue